import {InjectionToken} from '@angular/core';
import {legalDocuments} from './legal-documents';

//todo: type this
export type AssetMap = Record<string, any>;

export const ASSET_MAP = new InjectionToken<AssetMap>(
  'Provides an asset map for a given client.',
);

export const ASSET_MAPS = {
  ekstraklasa: {
    heroMain: {
      glowGradient: '/assets/img/ekstraklasa/hero-main/glow-gradient.png',
    },
    placeholders: {
      horizontal: '/assets/img/ekstraklasa/placeholders/placeholder-horizontal.svg',
      vertical: '/assets/img/ekstraklasa/placeholders/placeholder-vertical.svg',
    },
    comingSoonBackground: '/assets/img/ekstraklasa/coming-soon-background.png',
    metaImage: '/assets/img/ekstraklasa/default-image-meta-tags.jpeg',
    logo: '/assets/img/ekstraklasa/logo.svg',
    titleBarLogo: '/assets/img/ekstraklasa/title-bar-logo.svg',
    titleBarLogoMobile: '/assets/img/ekstraklasa/title-bar-logo-mobile.svg',

    logoHeader: '/assets/img/ekstraklasa/logo-header.png',
    footer: {
      logo: '/assets/img/ekstraklasa/footer-logo.svg',
      logoMobile: '/assets/img/ekstraklasa/footer-logo-mobile.svg',
      logoTablet: '/assets/img/ekstraklasa/footer-logo-tablet.svg',
    },
    consent: {
      dataProtectionPolicyUrl: (lang: string) =>
        `https://ekstraklasa.tv/${lang}/data-protection-policy`,
      dataOwner: 'Ekstraklasa Live Park Sp. z o.o.',
    },
    icons: {
      bannerDeviceLimit: '/assets/img/ekstraklasa/icons/banner-device-limit.svg',
      bannerGeolocation: '/assets/img/ekstraklasa/icons/banner-geolocation.svg',
      bannerLogin: '/assets/img/ekstraklasa/icons/banner-login.svg',
      bannerPadlock: '/assets/img/ekstraklasa/icons/banner-padlock.svg',
      error404: '/assets/img/ekstraklasa/icons/error-404.svg',
      error500: '/assets/img/ekstraklasa/icons/error-500.svg',
      logo: '/assets/img/ekstraklasa/icons/logo.svg#logo',
      padlock: '/assets/img/ekstraklasa/icons/padlock.svg',
      paymentError: '/assets/img/ekstraklasa/icons/payment-error.svg',
      paymentProcessing: '/assets/img/ekstraklasa/icons/payment-processing.svg',
      paymentSuccess: '/assets/img/ekstraklasa/icons/payment-success.svg',
      searchBig: '/assets/img/ekstraklasa/icons/search-big.svg',
      tv: '/assets/img/ekstraklasa/icons/tv.svg',
    },
  },
  lff: {
    heroMain: {
      glowGradient: '/assets/img/lff/hero-main/glow-gradient.png',
    },
    placeholders: {
      horizontal: '/assets/img/lff/placeholders/placeholder-horizontal.svg',
      vertical: '/assets/img/lff/placeholders/placeholder-vertical.svg',
    },
    comingSoonBackground: '/assets/img/lff/tv-banner.jpg',
    metaImage: '/assets/img/lff/tv-banner.jpg',
    logo: '/assets/img/lff/logo.svg',
    titleBarLogo: '',
    logoHeader: '/assets/img/lff/logo-golden-blue.svg',
    footer: {
      logo: '/assets/img/lff/logo-footer.svg',
      logoMobile: '/assets/img/lff/logo-footer-mobile.svg',
      logoTablet: '/assets/img/lff/logo-footer-tablet.svg',
    },
    icons: {
      bannerDeviceLimit: '/assets/img/lff/icons/banner-device-limit.svg',
      bannerGeolocation: '/assets/img/lff/icons/banner-geolocation.svg',
      bannerLogin: '/assets/img/lff/icons/banner-login.svg',
      bannerPadlock: '/assets/img/lff/icons/banner-padlock.svg',
      error404: '/assets/img/lff/icons/error-404.svg',
      error500: '/assets/img/lff/icons/error-500.svg',
      logo: '/assets/img/lff/icons/logo-black-blue.png',
      padlock: '',
      paymentError: '',
      paymentProcessing: '',
      paymentSuccess: '',
      searchBig: '/assets/img/lff/icons/search-big.svg',
      tv: '/assets/img/lff/icons/tv.svg',
    },
    docs: {
      dataProtectionPolicy: '/assets/docs/lff/privatumo-politika.pdf',
      terms: '/assets/docs/lff/bendrosios-nuostatos.pdf',
    },
  },
  tisa: {
    heroMain: {
      glowGradient: '/assets/img/tisa/hero-main/glow-gradient.png',
    },
    placeholders: {
      horizontal: '/assets/img/tisa/placeholders/placeholder-horizontal.svg',
      vertical: '/assets/img/tisa/placeholders/placeholder-vertical.svg',
    },
    comingSoonBackground: '/assets/img/tisa/tv-banner.jpeg',
    metaImage: '/assets/img/tisa/tv-banner.jpeg',
    logo: '/assets/img/tisa/logo.webp',
    titleBarLogo: '',
    logoHeader: '/assets/img/tisa/logo.webp',
    footer: {
      logo: '/assets/img/tisa/logo-footer.png',
      logoMobile: '/assets/img/tisa/logo-footer-mobile.png',
      logoTablet: '/assets/img/tisa/logo-footer-tablet.png',
    },
    icons: {
      bannerDeviceLimit: '/assets/img/tisa/icons/banner-device-limit.svg',
      bannerGeolocation: '/assets/img/tisa/icons/banner-geolocation.svg',
      bannerLogin: '/assets/img/tisa/icons/banner-login.svg',
      bannerPadlock: '/assets/img/tisa/icons/banner-padlock.svg',
      error404: '/assets/img/tisa/icons/error-404.svg',
      error500: '/assets/img/tisa/icons/error-500.svg',
      padlock: '',
      paymentError: '',
      paymentProcessing: '',
      paymentSuccess: '',
      searchBig: '/assets/img/tisa/icons/search-big.svg',
      tv: '/assets/img/tisa/icons/tv.svg',
    },
    docs: {
      dataProtectionPolicy: 'https://www.tisagroup.ch/privacy-policy/',
      terms: 'https://www.tisagroup.ch/privacy-policy/',
    },
  },
  ran: {
    placeholders: {
      horizontal: '',
      vertical: '',
    },
    comingSoonBackground: '',
    metaImage: '/assets/img/ran/default-meta-image.png',
    logo: '/assets/img/ran/logo.png',
    logoHeader: '/assets/img/ran/logo.png',
    footer: {},
    icons: {
      bannerDeviceLimit: '/assets/img/smart/icons/banner-device-limit.svg',
      bannerGeolocation: '/assets/img/smart/icons/banner-geolocation.svg',
      bannerLogin: '/assets/img/smart/icons/banner-login.svg',
      bannerPadlock: '/assets/img/smart/icons/banner-padlock.svg',
      error404: '/assets/img/smart/icons/ghost.svg',
      error500: '/assets/img/smart/icons/ghost.svg',
      padlock: 'assets/img/smart/icons/banner-padlock.svg',
      paymentError: 'assets/img/smart/icons/payment-error.svg',
      paymentProcessing: 'assets/img/smart/icons/payment-processing.svg',
      paymentSuccess: 'assets/img/smart/icons/payment-success.svg',
      searchBig: '/assets/img/smart/icons/ghost.svg',
      tv: '/assets/img/smart/icons/tv.svg',
    },
    docs: {
      dataProtectionPolicy:
        'https://www.termsfeed.com/live/68865ba5-e8f7-4c60-b73f-3bf585dba1dd',
      terms: 'https://www.termsfeed.com/live/f89e37d5-ef33-478f-b8ab-52295149aebd',
      cookiePolicy: 'https://www.termsfeed.com/live/01614056-e13b-49f4-b53c-9ff8819b5eee',
    },
  },
  legia: {
    placeholders: {
      horizontal: '',
      vertical: '',
    },
    comingSoonBackground: '',
    metaImage: '',
    logo: '/assets/img/legia/logo.svg',
    logoHeader: '/assets/img/legia/logo.svg',
    footer: {},
    consent: {
      dataProtectionPolicyUrl: (lang: string) =>
        `https://vod.legia.com/${lang}/data-protection-policy`,
      dataOwner: 'Legia Warszawa S.A.',
    },
    icons: {
      bannerDeviceLimit: '/assets/img/smart/icons/banner-device-limit.svg',
      bannerGeolocation: '/assets/img/smart/icons/banner-geolocation.svg',
      bannerLogin: '/assets/img/smart/icons/banner-login.svg',
      bannerPadlock: '/assets/img/smart/icons/banner-padlock.svg',
      error404: '/assets/img/smart/icons/ghost.svg',
      error500: '/assets/img/smart/icons/ghost.svg',
      padlock: 'assets/img/smart/icons/banner-padlock.svg',
      paymentError: 'assets/img/smart/icons/payment-error.svg',
      paymentProcessing: 'assets/img/smart/icons/payment-processing.svg',
      paymentSuccess: 'assets/img/smart/icons/payment-success.svg',
      searchBig: '/assets/img/smart/icons/ghost.svg',
      tv: '/assets/img/smart/icons/tv.svg',
    },
    docs: {
      dataProtectionPolicy: '',
      terms: '',
      informationObligation: {
        // TODO: move it into wicket legalDocuments
        pl: '/assets/docs/legia/information_obligation_pl.pdf',
        en: '/assets/docs/legia/information_obligation_en.pdf',
      },
    },
  },
  smart: {
    placeholders: {
      horizontal: '',
      vertical: '',
    },
    comingSoonBackground: '',
    metaImage: '/assets/img/smart/default-meta-image.png',
    logo: '',
    logoHeader: '',
    footer: {},
    icons: {
      bannerDeviceLimit: '/assets/img/smart/icons/banner-device-limit.svg',
      bannerGeolocation: '/assets/img/smart/icons/banner-geolocation.svg',
      bannerLogin: '/assets/img/smart/icons/banner-login.svg',
      bannerPadlock: '/assets/img/smart/icons/banner-padlock.svg',
      error404: '/assets/img/smart/icons/ghost.svg',
      error500: '/assets/img/smart/icons/ghost.svg',
      padlock: 'assets/img/smart/icons/banner-padlock.svg',
      paymentError: 'assets/img/smart/icons/payment-error.svg',
      paymentProcessing: 'assets/img/smart/icons/payment-processing.svg',
      paymentSuccess: 'assets/img/smart/icons/payment-success.svg',
      searchBig: '/assets/img/smart/icons/ghost.svg',
      tv: '/assets/img/smart/icons/tv.svg',
    },
    docs: {
      dataProtectionPolicy: '',
      terms: '',
      cookiePolicy: '',
    },
  },
};
